import http from '../http'
import { Res } from '../type'
import { UserInfo } from '../Models/UserInfo'
import { UserChangePwParams } from '@/api/Models/UserChangePw'
import { UserBindEmailParams } from '@/api/Models/UserBindEmail'
import { UserChangeAvatarParams } from '@/api/Models/UserChangeAvatar'
import { AccountLoginRequest, SendSMS } from '@/api/Models/LoginSendSMS'
import { UserBindMobileParams } from '@/api/Models/UserBindMobile'
import { FeedbackTypes } from '@/api/Models/FeedbackTypes'
import { FeedbackSubmitParams } from '@/api/Models/FeedbackSubmit'
import { FeedbackLeadersType } from '@/api/Models/CeoTypes'
import { CeoSubmitParams } from '@/api/Models/CeoSubmit'
import {
  UserChangePasswordParams,
  UserCheckPhoneCaptchaParams,
  UserCheckPhoneCaptchaResult,
  UserFirstChangePasswordParams
} from '../Models/UserCheckPhoneCaptcha'
import { ConfigSignatureParams, ConfigSignatureResult } from '@/api/Models/Feishu'
import { BindOpenParams, BindOpenResult, SignatureParams, SignatureResult } from '@/api/Models/UserBindOpen'
import { UserSwitchClient } from '@/api/Models/UserSwitchClient'
import { UserPageParams, UserPageResponse } from '@/api/Models/UserPage'
import { UserSwitchStatusParams } from '@/api/Models/UserSwitchStatus'
import { UserCreateParams, UserUpdateParams } from '@/api/Models/UserCreate'
import { UserResetPasswordParams } from '@/api/Models/UserResetPassword'
import { UserDetailParams, UserDetail } from '@/api/Models/UserDetail'
import dayjs from 'dayjs'

// 用户相关接口-获取登录用户信息
export const getUserInfo = (): Res<UserInfo> => {
  return http.request({
    url: '/sands-user/api/v1/user/current-info',
    method: 'get',
    loadingShow: '0'
  })
}

// 用户相关接口-修改密码
export const postUserChangePw = (data: UserChangePwParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/change-password',
    method: 'post',
    data
  })
}

// 用户相关接口-绑定邮箱
export const postUserBindEmail = (data: UserBindEmailParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/bind-email',
    method: 'post',
    data
  })
}

// 用户相关接口-绑定手机
export const postUserBindMobile = (data: UserBindMobileParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/bind-mobile',
    method: 'post',
    data
  })
}

// 用户相关接口-发送验证码
export const postSmsSend = (data: SendSMS): Res<{}> => {
  return http.request({
    url: '/sands-system/api/v1/sms/send-captcha',
    method: 'post',
    data
  })
}

// 修改头像
export const postUserChangeAvatar = (data: UserChangeAvatarParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/change-avatar',
    method: 'post',
    loadingShow: '0',
    data
  })
}

// 账号登录
export const accountLogin = (data: AccountLoginRequest): Res<UserSwitchClient> => {
  return http.request({
    url: '/sands-user/oauth/token',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json',
      Authorization: 'Basic c2FuZHNfYXBwOmNUY245NXdnc2JGNFJYTHA=',
      'accept-language': localStorage.getItem('lang') || 'zh-cn',
      'Common-Platform': 'H5',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      "Tenant-Id": localStorage.getItem('tenantId') || ''
    },
    toastShow: '0',
    loadingShow: '0',
    unLogin: '1'
  })
}

// 校验验证码
export const checksms = (data: UserCheckPhoneCaptchaParams): Res<UserCheckPhoneCaptchaResult> => {
  return http.request({
    url: '/sands-user/oauth/check-sms',
    method: 'post',
    data
  })
}

// 修改密码（根据手机号修改-登录使用）
export const changePassword = (data: UserChangePasswordParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/mobile-change-password',
    method: 'post',
    data
  })
}

// 首次修改密码（根据手机号修改-登录使用）
export const firstChangePassword = (data: UserFirstChangePasswordParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/change-password',
    method: 'post',
    data
  })
}

// 问题反馈

// 问题反馈-C端-查询问题分类
export const getFeedbackTypes = (): Res<FeedbackTypes[]> => {
  return http.request({
    url: '/sands-lms/api/v1/questionFeedbackCategory/questionList',
    method: 'get',
    loadingShow: '0'
  })
}

// 问题反馈-C端-创建问题反馈
export const postFeedbackSubmit = (data: FeedbackSubmitParams): Res<FeedbackTypes[]> => {
  return http.request({
    url: '/sands-lms/api/v1/questionFeedback/create',
    method: 'post',
    data,
    loadingShow: '0'
  })
}

// CEO直通车
// CEO直通车-反馈对象
export const getCeoTypes = (): Res<FeedbackLeadersType> => {
  return http.request({
    url: '/sands-user/api/v1/user/feedback-leaders',
    method: 'get',
    loadingShow: '0'
  })
}

// CEO直通车-C端-CEO直通车
export const postCeoSubmit = (data: CeoSubmitParams): Res<{}> => {
  return http.request({
    url: '/sands-lms/api/v1/ceo-channel/create',
    method: 'post',
    loadingShow: '0',
    data
  })
}

// 飞书签名接口
export const configSignature = (params: ConfigSignatureParams): Res<ConfigSignatureResult> => {
  return http.request({
    url: '/sands-user/api/v1/auth/feishu/config-signature',
    method: 'get',
    params,
    toastShow: '0',
    loadingShow: '0',
    unLogin: '1'
  })
}

// 微信通过code换取网页授权access_token拿到openId
export const OauthUserBindOpen = (data: BindOpenParams): Res<BindOpenResult> => {
  return http.request({
    url: '/sands-user/api/v1/user/bind-open',
    method: 'post',
    data,
    unLogin: '1'
  })
}

// 解绑
export const unBindOpen = (data: { type: string }): Res<{ code: number; msg: string }> => {
  return http.request({
    url: '/sands-user/api/v1/user/unbind-open',
    method: 'post',
    data
  })
}

// 微信签名接口
export const wxSignature = (params: SignatureParams): Res<SignatureResult> => {
  return http.request({
    url: '/sands-user/api/v1/auth/wechat/config-signature',
    method: 'get',
    params,
    unLogin: '1',
    toastShow: '0'
  })
}

export const getValidateToken = (): Res<UserInfo> => {
  return http.request({
    url: '/sands-user/api/v1/user/current-info',
    method: 'get',
    loadingShow: '0',
    unLogin: '1'
  })
}

export const getUserAppId = (): Res<{ code: number; msg: string }> => {
  return http.request({
    url: 'https://qyapi.weixin.qq.com/cgi-bin/service/get_provider_token',
    method: 'post'
  })
}

export const feishuAppid = (): Res<{ id: string; enterpriseName: string; appId: string; platformType: string }> => {
  const getTenantId = localStorage.getItem('sandsTalkTenantId') || ''
  const feishuTenantId = localStorage.getItem('feishuTenantId')
  return http.request({
    url: '/sands-user/api/v1/auth/login-methods?platformType=LARK_SUITE&tenantId=' + (feishuTenantId || getTenantId),
    method: 'get',
    toastShow: '0',
    loadingShow: '0',
    unLogin: '1'
  })
}

export const saveDuration = (stayDuration: number) => {
  return http.request({
    url: '/sands-user/api/v1/user/user-stay-duration/saveDuration',
    method: 'post',
    data: {
      stayDateTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      stayDuration,
      terminalType: 2
    },
    toastShow: '0',
    loadingShow: '0',
    unLogin: '1'
  })
}

// 用户管理-查询所有用户(分页)
export const getUserPage = (data: UserPageParams): Res<UserPageResponse> => {
  return http.request({
    url: '/sands-user/api/v1/user/page',
    method: 'post',
    loadingShow: '0',
    data
  })
}

// 用户管理-删除用户
export const deleteUser = (data: { id: number | string }): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/delete?id=' + data.id,
    method: 'post',
    data
  })
}

// 用户相关接口-启用/禁用用户
export const switchUserStatus = (data: UserSwitchStatusParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/switch-status',
    method: 'post',
    data
  })
}

// 用户相关接口-创建用户
export const createUser = (data: UserCreateParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/create',
    method: 'post',
    data
  })
}

// 用户相关接口-修改用户
export const updateUser = (data: UserUpdateParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/update',
    method: 'post',
    data
  })
}

// 用户相关接口-用户详情
export const getUserDetail = (params: UserDetailParams): Res<UserDetail> => {
  return http.request({
    url: '/sands-user/api/v1/user/get',
    method: 'get',
    loadingShow: '0',
    params
  })
}

// 用户相关接口-重置密码
export const resetUserPassword = (data: UserResetPasswordParams): Res<{}> => {
  return http.request({
    url: '/sands-user/api/v1/user/rest-password',
    method: 'post',
    data
  })
}
